import React from "react"
import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import { FormattedMessage } from "react-intl"

const StyledTypography = styled(Typography)({
  color: "#ffffff",
  fontSize: "12px",
  opacity: 0.7,
})

const TextCopyright = () => {
  return (
    <StyledTypography>
      <FormattedMessage id="Footer.CopyRight" />
    </StyledTypography>
  )
}

export default TextCopyright
